export default "__VITE_ASSET__BfDJ$$2A__"